<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#ee0909" type="ball-atom" [fullScreen]="true">
    <p style="color: white"> cargando .... </p>
</ngx-spinner>

<div class="container">
    <div class="row">
        <div class="border">
        </div>

        <app-sectores-organizacionales-tipo [title]="title" [sector]="sector" [ocupacion]="ocupacion" [nivel]="nivel"
            (itemSelected)="itemSelected($event)" *ngIf="sector && !ocupacion && !nivel && !estandar && !detalle"
            (backTo)="onBack($event)"></app-sectores-organizacionales-tipo>

        <app-sectores-organizacionales-tipo [title]="title" [sector]="sector" [ocupacion]="ocupacion" [nivel]="nivel"
            (itemSelected)="itemSelected($event)" *ngIf="!sector && ocupacion && !nivel && !estandar && !detalle" [padre]='padre' [hijo] = "hijo"
            (backTo)="onBack($event)"></app-sectores-organizacionales-tipo>

        <app-sectores-organizacionales-tipo [title]="title" [sector]="sector" [ocupacion]="ocupacion" [nivel]="nivel"
            (itemSelected)="itemSelected($event)" *ngIf="!sector && !ocupacion && !nivel  && !estandar && !detalle" [padre]='padre'  [hijo] = "hijo"
            (backTo)="onBack($event)"></app-sectores-organizacionales-tipo>
        
        <app-sectores-organizacionales-tabla-est [title]="title" [estandar]="estandar"
            (itemSelected)="itemSelected($event)" *ngIf="!sector && !ocupacion && nivel  && !estandar && !detalle" [hijo] = "hijo"
            (backTo)="onBack($event)"  (foo)='displayCounter($event)'></app-sectores-organizacionales-tabla-est>

        <desEstandares [title]="titleSt"  [codigoEC]="cadigoEC"  *ngIf="!sector && !ocupacion && !nivel  && !estandar && detalle"  (backTo)="onBack($event)" [hijo] = "hijo"></desEstandares>
    
    </div>
</div>